import create from 'zustand';
import { persist } from 'zustand/middleware';
import { SisenseAnalyticsState } from 'Modules/Shared/analytics/types/types';
import moment from 'moment';

export const useSisenseAnalyticsStore = create<SisenseAnalyticsState>(
  persist(
    (set): SisenseAnalyticsState => ({
      upcomingActivitiesStartDate: moment().toISOString(),
      upcomingActivitiesEndDate: moment().add(1, 'week').toISOString(),
      setUpcomingActivitiesStartDate: startDate =>
        set({ upcomingActivitiesStartDate: moment(startDate).toISOString() }),
      setUpcomingActivitiesEndDate: endDate =>
        set({ upcomingActivitiesEndDate: moment(endDate).toISOString() }),
      overdueActivitiesStartDate: moment().subtract(1, 'week').toISOString(),
      overdueActivitiesEndDate: moment().toISOString(),
      setOverdueActivitiesStartDate: startDate =>
        set({ overdueActivitiesStartDate: moment(startDate).toISOString() }),
      setOverdueActivitiesEndDate: endDate =>
        set({ overdueActivitiesEndDate: moment(endDate).toISOString() }),
      completedActivitiesStartDate: moment().subtract(1, 'week').toISOString(),
      completedActivitiesEndDate: moment().toISOString(),
      setCompletedActivitiesStartDate: startDate =>
        set({ completedActivitiesStartDate: moment(startDate).toISOString() }),
      setCompletedActivitiesEndDate: endDate =>
        set({ completedActivitiesEndDate: moment(endDate).toISOString() }),
      flowAnalyticsStartDate: moment().subtract(1, 'week').toISOString(),
      flowAnalyticsEndDate: moment().toISOString(),
      setFlowAnalyticsStartDate: startDate =>
        set({ flowAnalyticsStartDate: moment(startDate).toISOString() }),
      setFlowAnalyticsEndDate: endDate =>
        set({ flowAnalyticsEndDate: moment(endDate).toISOString() }),
      analyticsModal: null,
      openAnalyticsModal: (type, props) =>
        set({ analyticsModal: { type, props } }),
      closeAnalyticsModal: () => set({ analyticsModal: null }),
    }),
    {
      name: 'sisense-analytics-storage',
    }
  )
);
